import React from "react";
import PropTypes from "prop-types";
import EmployerCandidateActionsIEForm from "./EmployerCandidateActionsIEForm";
import RecruiterCandidateActionsIEForm from "./RecruiterCandidateActionsIEForm";

const ActionsIEForm = (props) => {
  const { updateStatusLink, offerMade, isEmployer } = props;
  return (
    <div>
      {isEmployer ? (
        <EmployerCandidateActionsIEForm
          updateStatusLink={updateStatusLink}
          offerMade={offerMade}
        />
      ) : (
        <RecruiterCandidateActionsIEForm
          updateStatusLink={updateStatusLink}
          offerMade={offerMade}
        />
      )}
    </div>
  );
};

ActionsIEForm.propTypes = {
  isEmployer: PropTypes.bool.isRequired,
  updateStatusLink: PropTypes.string,
  offerMade: PropTypes.bool.isRequired,
};

ActionsIEForm.defaultProps = {
  updateStatusLink: PropTypes.isNull,
};

export default ActionsIEForm;
